import { create } from "zustand";

export const useGifList = create((set) => ({
  celebrateGifs: [
    "/images/celebrate1.gif",
    "/images/celebrate2.gif",
    "/images/jonah-hill.gif",
    "/images/party.gif",
    "/images/party2.gif",
    "/images/cool.gif",
    "/images/money-cat.gif",
    "/images/random.gif",
  ],
  moneyCatGif: ["/images/money-cat.gif"],
  noGif: ["/images/darth-vader-no.gif"],
  dragon: ["/images/dragon.gif"],
}));
export const usePlayGif = create((set) => ({
  showGif: false,
  gifSrc: [],
  setShowGif: (value) => set(() => ({ showGif: value })),
  setGifSrc: (value) => set(() => ({ gifSrc: value })),
}));
